<template>
  <result-table
    :columns="columns"
    :data-source="data"
    :result="result"
    @clickSql="(val) => this.$emit('clickSql', val)"
  ></result-table>
</template>

<script>
import ResultTable from '@/components/Custom/ResultTable.vue'

export default {
  name: 'TabPaneResult',
  components: { ResultTable },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  watch:{
    result:{
      immediate: true,
      handler: function(){
        this.init()
      }
    }
  },
  data () {
    return {
      columns: [],
      data: []
    }
  },
  mounted(){
  },
  methods: {
    init(){
      const tempColumns = []
      this.result.columns.forEach(column => {
        const temp = {
          title: column.name,
          dataIndex: column.name,
          width: 160,
          ellipsis: true
        }
        tempColumns.push(temp)
      })
      this.columns = tempColumns
      this.data = this.result.rows
    }
  }
}
</script>

<style lang="less" scoped>
</style>

